import { Component, EventEmitter, Output, Input } from '@angular/core';
import { NoteUpd } from '../../shared/models/NoteUpd';
import { ConfirmOutput } from '../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../shared/enums/CPDialogResult';
import { CRUDActions } from '../../shared/enums/CRUDActions';
import { CommonFunctions } from '../../shared/static/common-functions';
import { BaseMessageInfo } from '../../shared/models/BaseMessageInfo';
import { MessageInfo } from '../../shared/models/MessageInfo';
import { GlobalsService } from '../../shared/services/globals.service';
import { DispatchAssignmentBus } from '@app/cp/shared/models/DispatchAssignmentBus';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { v_DispatchAssignmentBus } from '@app/cp/shared/models/v_DispatchAssignmentBus';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { BaseDQOIComponent } from '@app/cp/shared/base-components/base-dqoi.component';

@Component({
    selector: 'change-status-dialog',
    templateUrl: './change-status-dialog.component.html',
    styleUrls: ['./change-status-dialog.component.scss']
})
export class ChangeStatusDialogComponent  {
    constructor(globals: GlobalsService, private svc_data: DispatchesService) {

    }
    get referenceData(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }

    active: boolean = false;
    data: any;
    gridData: v_DispatchAssignmentBus[];
    action: CRUDActions;
    title: string;
    message: string;
    code: string;
    @Output() confirmation: EventEmitter<ConfirmOutput> = new EventEmitter<ConfirmOutput>();

    hide() {
        this.active = false;
        this.data = null;
        this.title = null;
        this.message = null;
        this.action = CRUDActions.None;
    }
    ok() {
        let result: ConfirmOutput = { action: this.action,  dialogResult: CPDialogResult.ok, data: this.gridData, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    cancel() {
        let result: ConfirmOutput = { action: this.action, dialogResult: CPDialogResult.cancel, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    close() {
        let result: ConfirmOutput = { action: this.action, dialogResult: CPDialogResult.close, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    public show(id: any) {
        this.svc_data.GetDispatchAssignments(id).subscribe((data: v_DispatchAssignmentBus[]) => {
            console.log("disp-cs-a:", data);
            if (CommonFunctions.hasArrayValue(data)) {
                let arr = [];
                for (let i = 0; i < data.length; i++) {
                    if (data[i].isCurrent === true) {
                        let dataObj: v_DispatchAssignmentBus = new v_DispatchAssignmentBus(data[i]);
                        dataObj.assignedPersonName = dataObj.fullName;
                        arr.push(dataObj);
                    }
                }
                this.gridData = arr;
            }
        })
//        this.title = CommonFunctions.getStringValueIfNull(title, "Please Confirm");
//        this.message = "There are Resources currently assigned to this Dispatch"
        this.active = true;
    }
}

